import styles from "./OutlinedButton.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

const OutlinedButton = (props: {
  title: string;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}) => {
  const {
    title,
    icon,
    iconPosition = "left",
    onClick,
    disabled = false,
    className,
  } = props;

  return (
    <button
      className={cx("outlined-button", className)}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && iconPosition === "left" && icon}
      <p className={cx("outlined-title")}>{title}</p>
      {icon && iconPosition === "right" && icon}
    </button>
  );
};

export default OutlinedButton;
